import React from 'react';
import AppShell from '@/components/layout/AppShell';
import { financeNav } from '@/lib/navConfig';
import ExpensesReport from '@/components/expenses/ExpensesReport';

export default function FinanceReports() {
  return (
    <AppShell nav={financeNav} title="Laporan Pengeluaran">
      <ExpensesReport />
    </AppShell>
  );
}
